import * as Yup from "yup";

export const initialValues = (data) => {
  console.log(data)
  return {
    ...data,
  };
};
export const structure = (_, __, t) => [
  {
    head: "",
    width: "100%",
    list: [
     {
        name: `key`,
        kind: "input",
        type: "text",
        label: t("system_configuration.key"),
        width: "47%",
        placeholder:"",
        disabled:true
      },
      {
        name: `value`,
        kind: "input",
        type: "text",
        label: t("system_configuration.value"),
        width: "47%",
        placeholder: t("system_configuration.write_value"),
      },
      {
        name: `description`,
        kind: "input",
        type: "text",
        label: t("system_configuration.description"),
        width: "47%",
        placeholder: t("system_configuration.write_description"),
      },
    ],
  },
];

export const validationSchema = () =>
  Yup.object({
    value:Yup.string().required("required"),
    // description:Yup.string().required("required"),
  });
